import { render } from "./SettingPosition.vue?vue&type=template&id=031e803a&scoped=true"
import script from "./SettingPosition.vue?vue&type=script&lang=js"
export * from "./SettingPosition.vue?vue&type=script&lang=js"

import "./SettingPosition.vue?vue&type=style&index=0&id=031e803a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031e803a"]])

export default __exports__